import { fixFloatError, getDecimalPlacesCount } from "helpers/math";

export default (odds: number, decimalRounding: number, minDecimalPlaces: number) => {
  const convertedOdd = fixFloatError(odds - 1);
  const decimalPlacesCount = getDecimalPlacesCount(convertedOdd);
  return convertedOdd.toFixed(decimalPlacesCount <= minDecimalPlaces ? minDecimalPlaces : decimalRounding);
};
